// responsive-scale.directive.ts
import { DirectiveBinding, ObjectDirective } from 'vue'
import { isMobie } from '@/utils/util';
import _ from 'lodash'

interface ScaleConfig {
  minScale?: number
  maxScale?: number
  breakpoint?: number
  padding?: number
}

const ResponsiveScale: ObjectDirective<any, ScaleConfig | number> = {
  mounted(el, binding) {
    // console.log('el----------', el.offsetWidth)
    const defaultConfig: Required<ScaleConfig> = {
      minScale: 0.2,
      maxScale: 100,
      breakpoint: 768,
      padding: 0,
    }

    // 处理绑定值
    const config: Required<ScaleConfig> = {
      ...defaultConfig,
      ...(typeof binding.value === 'number'
        ? { minScale: binding.value }
        : binding.value)
    }

    let originalWidth = isMobie() ? 960 : el.offsetWidth
    console.log('originalWidth-----', originalWidth)
    let originalHeight = el.offsetHeight
    console.log('originalHeight-----', originalHeight)
    let isScaling = false
    let resizeObserver: ResizeObserver | null = null

    const updateScale = () => {
      if (!isMobie()) {
        return
      }
      isScaling = true
      const viewportWidth = window.innerWidth
      console.log('viewportWidth-----', viewportWidth)

      if (originalWidth > 0) {
        const availableWidth = viewportWidth - (config.padding * 2)
        let scale = Math.min(availableWidth / originalWidth, config.maxScale)
        console.log('scale-----', scale)
        scale = Math.max(scale, config.minScale)

        el.style.transform = `scale(${scale})`
        el.style.transformOrigin = 'left top'
        // 关键修复：调整元素的实际占用空间
        el.style.width = `${originalWidth}px`
        el.style.height = `${originalHeight}px`
        el.style.margin = '0 auto'

        // 确保父容器正确包裹缩放后的内容

        let parentOriginalHeight = el.parentElement!.offsetHeight
        console.log('parentOriginalHeight-----', parentOriginalHeight)
        el.parentElement!.style.height = parentOriginalHeight - originalHeight * (1 - scale) + 'px'
        if (el.parentElement?.id === 'mainBox') {
          el.parentElement!.style.height -= 100
        }
        console.log('el.parentElement-----', el.parentElement.style.height)

        if (isScaling) {
          el.style.transition = 'transform 0.3s ease'
          setTimeout(() => {
            isScaling = false
          }, 300)
        }
      } else {
        resetScale()
      }
    }

    const resetScale = () => {
      el.style.transform = ''
      el.style.width = ''
      el.style.height = ''
      el.style.margin = ''
      isScaling = false
    }

    const handleResize = _.throttle(
      () => {
        console.log('handleResize----')

        if (isScaling || isMobie()) {
          return
        }
        const newWidth = isMobie() ? 960 : el.offsetWidth
        const newHeight = el.offsetHeight

        if (newWidth !== originalWidth || newHeight !== originalHeight) {
          originalWidth = newWidth
          originalHeight = newHeight
          console.log('originalWidth-----', originalWidth)
          console.log('originalHeight-----', originalHeight)
          updateScale()
        }
      }, 500)

    // 初始化
    updateScale()

    // 使用ResizeObserver监听元素大小变化
    resizeObserver = new ResizeObserver(handleResize)
    resizeObserver.observe(el)

    // 监听窗口resize
    window.addEventListener('resize', handleResize)

    // 将清理函数保存到元素上
    el._responsiveScaleCleanup = () => {
      window.removeEventListener('resize', handleResize)
      resizeObserver?.disconnect()
      resizeObserver = null
    }
  },

  beforeUnmount(el) {
    if (el.parentElement?.id == 'mainBox') {
      // console.log('清除mainbox高度，以免影响其他页面')
      el.parentElement.style.height = 'auto'
    }
  },

  unmounted(el) {
    // 调用保存的清理函数
    if (el._responsiveScaleCleanup) {
      // console.log('调用保存的清理函数-------')
      el._responsiveScaleCleanup()
      delete el._responsiveScaleCleanup

    }
  }
}

export default ResponsiveScale